import React, { useState } from "react";
import PopupForm from "./PopupForm.js"; // Import the Popup Form
import "./Bigdatasolution.css";

const Bigdatasolution = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <div className="big-data-container">
      {/* Hero Section */}
      <section className="hero-big-section">
        <div className="hero-content">
          <h1>Big Data Solution</h1>
          <p>
            Unlock the power of data with advanced analytics, AI-driven insights,
            and scalable data solutions.
          </p>
          <button className="cta-button" onClick={() => setIsPopupOpen(true)}>
            Connect Now!
          </button>
        </div>
      </section>

      {/* About Big Data */}
      <section className="about-big-section">
        <div className="about-content">
          <div className="vector-image">
            <img src="./big-img.png" alt="Big Data Vector" />
          </div>
          <div className="about-text">
            <h2>What is Big Data?</h2>
            <p>
              Big Data refers to extremely large and complex datasets that require 
              specialized tools and techniques for processing, analysis, and visualization.
            </p>
            <ul>
              <li>🔹 Data Collection from Various Sources</li>
              <li>🔹 Real-time Processing & Analysis</li>
              <li>🔹 AI-powered Insights & Predictions</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features-section">
        <h2 className="section-title">Why Choose Our Big Data Solution?</h2>
        <div className="features-grid">
          <div className="feature-card">
            <span className="feature-icon">🚀</span>
            <h3>Scalability</h3>
            <p>Handle massive datasets with cloud-based solutions.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">🛡️</span>
            <h3>Security</h3>
            <p>Ensure data protection with industry-grade encryption.</p>
          </div>
          <div className="feature-card">
            <span className="feature-icon">📈</span>
            <h3>AI-Powered Insights</h3>
            <p>Leverage AI & ML for predictive analytics and automation.</p>
          </div>
        </div>
      </section>

      {/* Popup Form Component */}
      <PopupForm isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </div>
  );
};

export default Bigdatasolution;
